/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { BillListResponse } from '../model';
// @ts-ignore
import { BillResponse } from '../model';
// @ts-ignore
import { ReserveType } from '../model';
// @ts-ignore
import { TripSearchMode } from '../model';
/**
 * UserBillsApiApiBillsGet - axios parameter creator
 * 
 * @param {string} [xPlayerId] 
 * @param {string} [billCode] 
 * @param {string} [passengerName] 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {Array<ReserveType>} [reserveTypes] 
 * @param {Array<TripSearchMode>} [searchModes] 
 * @param {boolean} [pastTripsOnly] 
 * @param {boolean} [ongoingTripsOnly] 
 * @param {number} [pageNumber] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserBillsApiApiBillsGetAxiosParamCreator (xPlayerId?: string, billCode?: string, passengerName?: string, from?: string, to?: string, reserveTypes?: Array<ReserveType>, searchModes?: Array<TripSearchMode>, pastTripsOnly?: boolean, ongoingTripsOnly?: boolean, pageNumber?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/bills`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['BillCode'] = billCode;
    }

    if (passengerName !== undefined) {
        localVarQueryParameter['PassengerName'] = passengerName;
    }

    if (from !== undefined) {
        localVarQueryParameter['From'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (reserveTypes) {
        localVarQueryParameter['ReserveTypes'] = reserveTypes;
    }

    if (searchModes) {
        localVarQueryParameter['SearchModes'] = searchModes;
    }

    if (pastTripsOnly !== undefined) {
        localVarQueryParameter['pastTripsOnly'] = pastTripsOnly;
    }

    if (ongoingTripsOnly !== undefined) {
        localVarQueryParameter['ongoingTripsOnly'] = ongoingTripsOnly;
    }

    if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
    }

    if (xPlayerId != null) {
        localVarHeaderParameter['X-Player-Id'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserBillsApiApiBillsUserBillsGet - axios parameter creator
 * 
 * @param {number} userId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserBillsApiApiBillsUserBillsGetAxiosParamCreator (userId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiBillsUserBillsGet', 'userId', userId)
    const localVarPath = `/api/bills/user-bills`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiBillsGet operation in UserBillsApi.
 * @export
 * @interface UserBillsApiApiBillsGetRequest
 */
export interface UserBillsApiApiBillsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly xPlayerId?: string

    /**
     * 
     * @type {string}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly billCode?: string

    /**
     * 
     * @type {string}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly passengerName?: string

    /**
     * 
     * @type {string}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly to?: string

    /**
     * 
     * @type {Array<ReserveType>}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly reserveTypes?: Array<ReserveType>

    /**
     * 
     * @type {Array<TripSearchMode>}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly searchModes?: Array<TripSearchMode>

    /**
     * 
     * @type {boolean}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly pastTripsOnly?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly ongoingTripsOnly?: boolean

    /**
     * 
     * @type {number}
     * @memberof UserBillsApiApiBillsGet
     */
    readonly pageNumber?: number
}

/**
 * Request parameters for apiBillsUserBillsGet operation in UserBillsApi.
 * @export
 * @interface UserBillsApiApiBillsUserBillsGetRequest
 */
export interface UserBillsApiApiBillsUserBillsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserBillsApiApiBillsUserBillsGet
     */
    readonly userId: number
}

/**
* 
* @param {UserBillsApiApiBillsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserBillsApiApiBillsGet(requestParameters: UserBillsApiApiBillsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserBillsApiApiBillsGetAxiosParamCreator(requestParameters.xPlayerId, requestParameters.billCode, requestParameters.passengerName, requestParameters.from, requestParameters.to, requestParameters.reserveTypes, requestParameters.searchModes, requestParameters.pastTripsOnly, requestParameters.ongoingTripsOnly, requestParameters.pageNumber, options, configuration);
    const request: () => AxiosPromise<BillListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserBillsApiApiBillsUserBillsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserBillsApiApiBillsUserBillsGet(requestParameters: UserBillsApiApiBillsUserBillsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserBillsApiApiBillsUserBillsGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<Array<BillResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
